var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFSynonym = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#008060",
  clipPath: "url(#f-synonym_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.46 14.94-2.52-2.52c.81-1.26 1.26-2.7 1.26-4.32 0-4.5-3.6-8.1-8.1-8.1S0 3.6 0 8.1s3.6 8.1 8.1 8.1c1.62 0 3.06-.45 4.32-1.26l2.52 2.52c.72.72 1.8.72 2.52 0s.72-1.8 0-2.52M8.1 14.4c-3.51 0-6.3-2.79-6.3-6.3s2.79-6.3 6.3-6.3 6.3 2.79 6.3 6.3-2.79 6.3-6.3 6.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 9c-.54 0-.9-.36-.9-.9 0-2.52 1.98-4.5 4.5-4.5.54 0 .9.36.9.9s-.36.9-.9.9c-1.53 0-2.7 1.17-2.7 2.7 0 .54-.36.9-.9.9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "f-synonym_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export { SvgFSynonym as ReactComponent };
export default __webpack_public_path__ + "static/media/f-synonym.1b1d3a79.svg";